import React from 'react';

function BookingField({ label, children, fullWidth = false }) {
  return (
    <label className={`field ${fullWidth ? 'field--full' : ''}`}>
      {label}
      {children}
    </label>
  );
}

export default BookingField;
